module.exports = __webpack_public_path__ + "media/images/chas-d988f5bd44f74c86bb48d2e07ab6fe4e.png";